import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { NOTIFY } from "@/constants/testIds";

export const TestButton = ({ channel, userId, disabled }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await api.post("/notify-settings/test", { channel, user_id: userId || null });
      toast.success("Pesan tes terkirim");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const label = { email: "Tes email", whatsapp: "Tes WhatsApp", telegram: "Tes Telegram" }[channel];
  return (
    <Button type="button" variant="outline" size="sm" className="rounded-full" disabled={disabled || busy} onClick={run} data-testid={`${NOTIFY.test}-${channel}${userId ? `-${userId}` : ""}`}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : label}
    </Button>
  );
};
